import { ReportsComponent } from './reports/reports.component';
import { MainComponent } from './main/main.component';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { AuthGuard } from './security/auth.guard';
import { UserverificationComponent } from './userverification/userverification.component';
import { LogoutComponent } from './logout/logout.component';
import { BackHandleComponent } from './backnavigationhandle/backnavigationhandle';
import { ChangeHistoryComponent } from './change-history/change-history.component';
// Main route has to be called "main" for now.
// See example below
const appRoutes: Routes = [
  { path: 'welcome', redirectTo: 'welcome', pathMatch: 'full' },
  { path: 'authorities', component: MainComponent, canActivate: [AuthGuard] },
  { path: 'reports', component: ReportsComponent },
  { path: 'verify', component: UserverificationComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'history', component: ChangeHistoryComponent },
  { path: 'back', component: BackHandleComponent },
  { path: '', redirectTo: 'back', pathMatch: 'full' }];

export const Routing = RouterModule.forRoot(appRoutes, { useHash: true });
